import React, { useEffect, useState } from 'react';
import { Film, MessageSquarePlus, Hexagon } from 'lucide-react';

function App() {
  const [isFrench, setIsFrench] = useState(false);

  useEffect(() => {
    // Detect browser language
    const userLang = navigator.language || navigator.userLanguage;
    setIsFrench(userLang.startsWith('fr'));
  }, []);

  const content = {
    welcome: isFrench ? 'Bienvenue sur Hive Five' : 'Welcome to Hive Five',
    subtitle: isFrench ? 'Accédez à votre médiathèque ou demandez du nouveau contenu' : 'Access your media library or request new content',
    jellyfinTitle: isFrench ? 'Jellyfin' : 'Jellyfin',
    jellyfinDesc: isFrench ? 'Accédez à votre médiathèque et commencez à regarder' : 'Access your media library and start streaming',
    requestsTitle: isFrench ? 'Demandes' : 'Requests',
    requestsDesc: isFrench ? 'Demandez l\'ajout de nouveaux films et séries TV' : 'Request new movies and TV shows to be added',
  };

  return (
    <div className="min-h-screen bg-[#121212] flex flex-col items-center justify-center p-4 relative">
      {/* Background overlay with subtle pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f172a] to-[#1e1b4b] opacity-90 z-0"></div>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl">
        <div className="text-center mb-12 flex flex-col items-center">
          {/* Hive Logo */}
          <div className="mb-6 relative">
            <Hexagon size={80} className="text-amber-400 fill-amber-400/20" strokeWidth={1.5} />
            <Hexagon size={60} className="text-amber-400 fill-amber-400/10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" strokeWidth={1.5} />
            <Hexagon size={40} className="text-amber-400 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" strokeWidth={1.5} />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">{content.welcome}</h1>
          <p className="text-xl text-indigo-200">{content.subtitle}</p>
        </div>
        
        <div className="flex flex-col md:flex-row gap-6 w-full">
          <a 
            href="https://jellyfin.hivefive.fr/" 
            className="flex-1 bg-gradient-to-br from-[#0284c7] to-[#0369a1] hover:from-[#0369a1] hover:to-[#0284c7] transition-all duration-300 rounded-xl shadow-lg overflow-hidden group border border-sky-700/30"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="p-8 flex flex-col items-center text-center">
              <Film size={80} className="text-white mb-6 group-hover:scale-110 transition-transform duration-300" />
              <h2 className="text-3xl font-bold text-white mb-3">{content.jellyfinTitle}</h2>
              <p className="text-sky-100">{content.jellyfinDesc}</p>
            </div>
          </a>
          
          <a 
            href="https://request.hivefive.fr/" 
            className="flex-1 bg-gradient-to-br from-[#7e22ce] to-[#6b21a8] hover:from-[#6b21a8] hover:to-[#7e22ce] transition-all duration-300 rounded-xl shadow-lg overflow-hidden group border border-purple-700/30"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="p-8 flex flex-col items-center text-center">
              <MessageSquarePlus size={80} className="text-white mb-6 group-hover:scale-110 transition-transform duration-300" />
              <h2 className="text-3xl font-bold text-white mb-3">{content.requestsTitle}</h2>
              <p className="text-purple-100">{content.requestsDesc}</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;